export default __webpack_public_path__ + "static/media/setupguitarra.0cab61b1.png";